import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";

import IconWel from "../assets/icon-nav-wel.png";
import IconAcn from "../assets/icon-nav-acn.png";
import IconAdLove from "../assets/icon-nav-adlove.png";
import IconCheckIn from "../assets/icon-nav-checkin.png";
import IconCRing from "../assets/icon-nav-cring.png";
import IconBPrs from "../assets/icon-nav-bprs.png";
import IconHVut from "../assets/icon-nav-hvault.png";
import IconPPDel from "../assets/icon-nav-ppdel.png";
import IconPRate from "../assets/icon-nav-prate.png";
import IconRole from "../assets/icon-nav-role.png";
import IconRight from "../assets/icon-nav-right.png";
import IconTemp from "../assets/icon-nav-tem.png";
import IconRRate from "../assets/icon-nav-rrate.png";
import IconBSug from "../assets/icon-nav-bsug.png";
import IconOSat from "../assets/icon-nav-osat.png";
import IconFeedback from "../assets/icon-nav-fback.png";
import IconRNose from "../assets/icon-nav-rnose.png";
import IconCough from "../assets/icon-nav-cough.png";
import IconUrine from "../assets/icon-nav-urine.png";
import IconVitals from "../assets/icon-nav-vitals.png";
import IconSymptoms from "../assets/icon-nav-symptoms.png";
import IconRMonitoring from "../assets/icon-nav-rmonitoring.png";
import IconHPReports from "../assets/icon-nav-hvprpts.png";
import IconHRReports from "../assets/icon-nav-hvrdr.png";
import IconHOthers from "../assets/icon-nav-hvothrs.png";
import IconCRLocalCare from "../assets/icon-nav-cr-lcr.png";
import IconCRAddFmlyMem from "../assets/icon-nav-cr-afm.png";
import IconCRAddDoc from "../assets/icon-nav-cr-adoc.png";
import IconCRALovedOne from "../assets/icon-nav-cr-alo.png";

export const SidebarData = [
  {
    title: "Welcome",
    path: "/moduleSummary",
    icon: IconWel,
  },
  {
    title: "Remote Monitoring",
    path: "/remote",
    icon: IconRMonitoring,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "Dashboard",
        path: "/dailyCheckInSummary",
        icon: IconCheckIn,
      },
      {
        title: "Vitals Summary",
        path: "/vitalsSummary",
        icon: IconAcn,
      },
    ],
  },
  {
    title: "Role",
    path: "/role",
    icon: IconRole,
  },
  // {
  //   title: "Add Loved Ones",
  //   path: "/addLovedOnes",
  //   icon: IconAdLove,
  // },
  {
    title: "Patient Particulars",
    path: "/patientpersonalDetailsForm",
    icon: IconPPDel,
  },
  {
    title: "Care Ring Management",
    icon: IconCRing,
    path: "/careRingsConsent",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Add Loved Ones",
        path: "/addLovedOnes",
        icon: IconAdLove,
      },
      {
        title: "Add Local Care Givers",
        path: "/localCareGiversConsent",
        icon: IconCRLocalCare,
      },
      {
        title: "Add Family Members",
        path: "/familyMembersConsent",
        icon: IconCRAddFmlyMem,
      },
      {
        title: "Add Doctor",
        path: "/comingSoon",
        icon: IconCRAddDoc,
      },
      {
        title: "Manage Consent",
        path: "/comingSoon",
        icon: IconPPDel,
      },
    ],
  },
  {
    title: "Health Vault",
    path: "/healthReports",
    icon: IconHVut,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Pathology Reports",
        path: "/healthReports",
        icon: IconHPReports,
      },
      {
        title: "Radiology Reports",
        path: "/healthReports",
        icon: IconHRReports,
      },
      {
        title: "Other Reports",
        path: "/healthReports",
        icon: IconHOthers,
      },
    ],
  },

  {
    title: "Vitals",
    path: "/vitals",
    icon: IconVitals,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "Blood Pressure",
        path: "/bloodPressure",
        icon: IconBPrs,
      },
      {
        title: "Pulse Rate",
        path: "/pulseRate",
        icon: IconPRate,
      },
      {
        title: "Oxygen Saturation",
        path: "/oxygenSaturation",
        icon: IconOSat,
      },
      {
        title: "Blood Sugar",
        path: "/bloodSugar",
        icon: IconBSug,
      },
      {
        title: "Temperature",
        path: "/temperature",
        icon: IconTemp,
      },
      {
        title: "Breathing Rate",
        path: "/breathingRate",
        icon: IconRRate,
      },
    ],
  },
  {
    title: "Symptoms",
    path: "/symptoms",
    icon: IconSymptoms,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "Nose",
        path: "/runnyNose",
        icon: IconRNose,
      },
      {
        title: "Cough",
        path: "/cough",
        icon: IconCough,
      },
      {
        title: "Urine",
        path: "/urine",
        icon: IconUrine,
      },
    ],
  },
  {
    title: "Check-In",
    icon: IconCheckIn,
    path: "/dailyCheckIn",
  },
  // {
  //   title: "Vitals Summary",
  //   path: "/vitalsSummary",
  //   icon: IconAcn
  // },
  {
    title: "Account",
    path: "/careManagerDetails",
    icon: IconAcn,
  },
  {
    title: "Feedback",
    path: "/userFeedbackForm",
    icon: IconPPDel,
  },
];
